"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useEnvironment = void 0;
var _react = require("react");
var _constants = require("../../../constants");
var _environmentContext = require("../environmentContext");
const useEnvironment = () => {
  const {
    environment = _constants.ENVIRONMENT_CODES.LIVE,
    tenant
  } = (0, _react.useContext)(_environmentContext.environmentContext);
  return (0, _react.useMemo)(() => ({
    environment,
    tenant
  }), [environment, tenant]);
};
exports.useEnvironment = useEnvironment;
//# sourceMappingURL=useEnvironment.js.map